import { render } from "./OverviewNote.vue?vue&type=template&id=5bdf218d&scoped=true"
import script from "./OverviewNote.vue?vue&type=script&lang=js"
export * from "./OverviewNote.vue?vue&type=script&lang=js"

import "./OverviewNote.vue?vue&type=style&index=0&id=5bdf218d&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bdf218d"]])

export default __exports__